import { Button } from 'antd';
import React from 'react';
import { SocialIcon } from '..';
import { MIDDLE_STYLE } from '@constants/responsive';
import { useAppDispatch } from '@core/configureStore';
import { openDrawer } from '@core/features';

type Props = {
  style?: React.CSSProperties;
};

const BrowseBusinessPhotoButton = ({ style }: Props) => {
  const dispatch = useAppDispatch();
  const handleBrowseBusinessPhoto = () => {
    dispatch(
      openDrawer({
        drawerName: 'businessPhotoBrowseDrawer',
      })
    );
  };
  return (
    <Button onClick={handleBrowseBusinessPhoto} style={{ ...MIDDLE_STYLE, ...style }}>
      <SocialIcon platform="google" width={20} />
      <span style={{ marginLeft: 10 }}>Browse Business Photo</span>
    </Button>
  );
};

export default BrowseBusinessPhotoButton;
